export const MOCK_EMAILS_RESPONSE = {
  count: 4,
  total_pages: 1,
  current_page: 1,
  results: [
    { email: 'admin@example.com', username: 'admin', domain: 'example.com' },
    { email: 'info@example.com', username: 'info', domain: 'example.com' },
    { email: 'support@acme.io', username: 'support', domain: 'acme.io' },
    { email: 'dev@acme.io', username: 'dev', domain: 'acme.io' },
  ],
}

export const MOCK_EMAIL_FILTER_OPTIONS = {
  domain: ['example.com', 'acme.io'],
}
